import Adicionar from './Adicionar';
import AlterarMinhaSenha from './AlterarMinhaSenha';
import Login from './Login';
import Perfil from './Perfil';

export const UsuariosAdicionar = Adicionar;
export const UsuariosAlterarMinhaSenha = AlterarMinhaSenha
export const UsuariosLogin = Login;
export const UsuariosPerfil = Perfil;
